// Kurum çekirdeği: canlı harita, seferler, kişiler, talepler, rotalar, belge uyumu, duyurular, kullanıcılar (B02–B13, B20,
// B25, B26): yönlendirmeler (izin + bayrak korumalı, tembel yüklenir). Genel bakış (B01, index) raporlar alanındadır.
import { Route } from 'react-router';
import { guard, load } from '../../control/route-utils';

const Live = load(() => import('./trips'), 'BusinessLive');
const Trips = load(() => import('./trips'), 'BusinessTrips');
const TripHistory = load(() => import('./trips'), 'BusinessTripHistory');
const TripDetail = load(() => import('./trips'), 'BusinessTripDetail');
const Employees = load(() => import('./People'), 'Employees');
const Students = load(() => import('./People'), 'Students');
const PersonDetail = load(() => import('./PersonDetail'), 'PersonDetail');
const EmployeeForm = load(() => import('./PersonForm'), 'EmployeeForm');
const StudentForm = load(() => import('./PersonForm'), 'StudentForm');
const Requests = load(() => import('./Requests'), 'Requests');
const RequestApproval = load(() => import('./RequestApproval'), 'RequestApproval');
const RoutesList = load(() => import('./RoutesList'), 'RoutesList');
const RouteView = load(() => import('./RouteView'), 'RouteView');
const Compliance = load(() => import('./Compliance'), 'Compliance');
const Announcements = load(() => import('./Announcements'), 'Announcements');
const AnnouncementCompose = load(() => import('./AnnouncementCompose'), 'AnnouncementCompose');
const Users = load(() => import('./Users'), 'Users');

export const businessCoreRoutes = (
  <>
    <Route path="canli" element={guard(Live, 'operations')} />
    <Route path="seferler" element={guard(Trips, 'trips')} />
    <Route path="seferler/gecmis" element={guard(TripHistory, 'trips')} />
    <Route path="seferler/:id" element={guard(TripDetail, 'trips')} />
    <Route path="calisanlar" element={guard(Employees, 'passengers')} />
    <Route path="calisanlar/yeni" element={guard(EmployeeForm, 'passengers', { action: 'edit' })} />
    <Route path="calisanlar/:id" element={guard(PersonDetail, 'passengers')} />
    <Route path="ogrenciler" element={guard(Students, 'passengers', { flag: 'SCHOOL' })} />
    <Route path="ogrenciler/yeni" element={guard(StudentForm, 'passengers', { action: 'edit', flag: 'SCHOOL' })} />
    <Route path="ogrenciler/:id" element={guard(PersonDetail, 'passengers', { flag: 'SCHOOL' })} />
    <Route path="talepler" element={guard(Requests, 'requests')} />
    <Route path="talepler/:id" element={guard(RequestApproval, 'requests')} />
    <Route path="rotalar" element={guard(RoutesList, 'routes')} />
    <Route path="rotalar/:id" element={guard(RouteView, 'routes')} />
    <Route path="belge-uyumu" element={guard(Compliance, 'compliance')} />
    <Route path="duyurular" element={guard(Announcements, 'announcements')} />
    <Route path="duyurular/yeni" element={guard(AnnouncementCompose, 'announcements', { action: 'edit' })} />
    <Route path="duyurular/:id/duzenle" element={guard(AnnouncementCompose, 'announcements', { action: 'edit' })} />
    <Route path="kullanicilar" element={guard(Users, 'team')} />
  </>
);
